/*
 * api 接口列表
 */
import {
  axiosPut,
  axiosGet,
  axiosPost,
  axiosDelete
} from './require'

const api = {
  // 用户取消收藏
  logout: () => axiosDelete('/auth/token/logout', {}),
  // 图形验证码相关接口
  reqGet: (params) => axiosGet('/code', params),
  reqCheck: (params) => axiosPost('/code/check', params),
  // 信息验证相关接口
  customerPhoneCheck: (params) => axiosGet('/ship/shipcustomer/exist/phone/' + params.phone, {}),
  supplierPhoneCheck: (params) => axiosGet('/ship/shipsupplier/exist/phone/' + params.phone, {}),
  customerUserNameCheck: (params) => axiosGet('/ship/shipcustomer/exist/username/' + params.userName, {}),
  supplierUserNameCheck: (params) => axiosGet('/ship/shipsupplier/exist/username/' + params.userName, {}),
  // 短信验证码
  getPhoneCode: (params) => axiosGet('/ship/mobile/register/' + params.phone, {}),
  // 重置密码短信验证码
  getPhoneCodeReset: (params) => axiosGet('/ship/mobile/reset/' + params.phone, {}),
  // 注册相关接口
  supplierRegisterStep1: (params) => axiosPost('/ship/shipsupplier/registerStep1', params),
  customerRegisterStep1: (params) => axiosPost('/ship/shipcustomer/registerStep1', params),
  supplierRegisterStep2: (params) => axiosPut('/ship/shipsupplier/registerStep2', params),
  customerRegisterStep2: (params) => axiosPut('/ship/shipcustomer/registerStep2', params),
  // 消息数据接口
  getShipMessage: (params) => axiosGet('/ship/shipmessage/page', params),
 
}

export default api



// WEBPACK FOOTER //
// ./src/utils/api.js